import { Component, computed, signal, inject } from '@angular/core';
import { IrisDMSFolderI } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';
import { IrisFoldersService } from '@iris/common/services/docs/folders.service';
import { IrisCopyFieldComponent } from '@iris/common/modules/copy-field/copy-field.component';
import { UpperCasePipe } from '@angular/common';
import { SkModalBase, SkModalContentComponent } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-folder-share-link-modal',
  imports: [
    TranslatePipe,
    UpperCasePipe,
    IrisCopyFieldComponent,
    SkModalContentComponent,
  ],
  templateUrl: './folder-share-link-modal.component.html',
  styleUrls: ['./folder-share-link-modal.component.scss'],
})
export class IrisDmsFolderShareLinkModalComponent extends SkModalBase<IrisDmsFolderShareLinkModalComponent, void> {
  private readonly translateService = inject(TranslateService);
  private readonly foldersService = inject(IrisFoldersService);
  private readonly toastService = inject(ToastService);

  readonly folder = signal<IrisDMSFolderI>(inject<{ folder: IrisDMSFolderI }>(MAT_DIALOG_DATA).folder);
  readonly internalLink = computed(() => this.foldersService.getFolderSourceUrl(this.folder()?.id));

  onCopyLink(): void {
    this.toastService.success({ message: this.translateService.instant('text.dms.FileShareLinkCopied') });
  }
}
